<template>
  <component :blok="story.content" :is="story.content.component"></component>
</template>

<script>
// 1. Require the Storyblok client
import StoryblokClient from "storyblok-js-client";

// 2. Set your token - you will be able to create a new space later.
const token = "mtrZQdPxUdnYYIe5m1buQgtt";

// 3. Initialize the client with the preview token so we can access our API easily
// from your space dashboard at https://app.storyblok.com
// eslint-disable-next-line no-unused-vars
let storyapi = new StoryblokClient({
  accessToken: token
});

export default {
  name: "CarouselWrapper",
  data() {
    return {
      story: {
        content: {
          body: []
        }
      }
    };
  },
  created() {
    window.storyblok.init({
      accessToken: token
    });
    window.storyblok.on("change", () => {
      // this will indicate to load the home story, exchange that with the full slug of your content
      // either it is the page URL or hardcoded as in the example below
      this.getStory("6f43fd0a-3595-48ee-bb13-cf1a86510809", "draft");
    });
    window.storyblok.pingEditor(() => {
      if (window.storyblok.isInEditor()) {
        this.getStory("6f43fd0a-3595-48ee-bb13-cf1a86510809", "draft");
      } else {
        this.getStory("6f43fd0a-3595-48ee-bb13-cf1a86510809", "published");
      }
    });
  },
  methods: {
    getStory(slug, version) {
      storyapi
        .get("cdn/stories/" + slug, {
          version: version
        })
        .then(response => {
          this.story = response.data.story;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped></style>
